export const date_format = 'DD-MM-YYYY';

export const dateFormat = {
  de: 'DD.MM.YYYY',
  en: 'DD-MM-YYYY',
};
